import React, { useState, useEffect } from "react";
import Modal from "../../../components/modal";
import { API_URL } from "../../../utils/constant";
import axios from "axios";
import { Link } from "react-router-dom";
import AddPurchases from "../purchases/add_purchases";
import { fetchRawCategories } from "../../../slices/company/rawCategorySlice";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { createProduct } from "../../../slices/company/rawProductSlice";
import { fetchSuppliers } from "../../../slices/company/supplierSlice";
import { fetchProductAttributes, selectAllProductAttributes } from "../../../slices/company/productAttributeSlice";

const RawMaterialStockForm = ({ show, onClose, heading, initialData = {}, rawProducts }) => {

    const dispatch = useDispatch();
    const [selectedVendors, setSelectedVendors] = useState([]);
    // const attributes = useSelector(selectAllProductAttributes);
    const [showModal, setShowModal] = useState(false);
    const [modalHeading, setModalHeading] = useState('Add Product');
    const { rawCategories } = useSelector(state => state.rawCategories);
    const { suppliers } = useSelector((state) => state.suppliers);
    const [variantStock, setVariantStock] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [tagInputs, setTagInputs] = useState({}); // NEW: Track tag inputs for each row

    // NEW: Handle tag input changes
    const handleTagInputChange = (rowIndex, value) => {
        setTagInputs(prev => ({
            ...prev,
            [rowIndex]: value
        }));
    };

    // NEW: Handle tag input key press (Enter to add tag)
    const handleTagInputKeyPress = (rowIndex, e) => {
        if (e.key === 'Enter' && e.target.value.trim()) {
            e.preventDefault();
            const newTag = e.target.value.trim();
            const updated = [...variantStock];
            if (!Array.isArray(updated[rowIndex].serial_no)) {
                updated[rowIndex].serial_no = [];
            }
            
            // Check if quantity is set and if adding this tag would exceed the quantity
            const currentQuantity = parseInt(updated[rowIndex].quantity) || 0;
            const currentSerialCount = updated[rowIndex].serial_no.length;
            
            if (currentQuantity > 0 && currentSerialCount >= currentQuantity) {
                alert(`Cannot add more serial numbers. Quantity is ${currentQuantity} and you already have ${currentSerialCount} serial numbers.`);
                return;
            }
            
            if (!updated[rowIndex].serial_no.includes(newTag)) {
                updated[rowIndex].serial_no.push(newTag);
            }
            setVariantStock(updated);
            setTagInputs(prev => ({
                ...prev,
                [rowIndex]: ''
            }));
        }
    };

    // NEW: Remove tag
    const removeTag = (rowIndex, tagToRemove) => {
        const updated = [...variantStock];
        updated[rowIndex].serial_no = updated[rowIndex].serial_no.filter(tag => tag !== tagToRemove);
        setVariantStock(updated);
    };

    // useEffect(() => {
    //     const company = JSON.parse(localStorage.getItem("company"));
    //     if (company) {
    //         const companyId = company.company?.id;
    //         dispatch(fetchProductAttributes(companyId));
    //     }
    // }, [dispatch]);


    useEffect(() => {
        const company = JSON.parse(localStorage.getItem('company'));
        if (company) {
            dispatch(fetchSuppliers(company.company?.id));
        }
    }, [dispatch]);
    // Fetch raw categories when the component mounts
     useEffect(() => {
        const company = JSON.parse(localStorage.getItem('company'));
        if (company) {
            const companyId = company.company?.id;
            dispatch(fetchRawCategories(companyId));
        }
    }, [dispatch]);

    const handleFormSubmit = (formData) => {
        dispatch(createProduct(formData));
        setShowModal(false);
        window.location.reload();
        
    };

    console.log('inittial', initialData);
    const [formData, setFormData] = useState({
        raw_product_id: initialData.raw_product_id || "",
        product_name: initialData.product_name || "",
        product_code: initialData.product_code || "",
        item_number: initialData.item_number || "",
        supplier_id: initialData.supplier_id || "", // Corrected supplier_id initialization
        purchase_date: initialData.purchase_date || "",
        purchase_by: initialData.purchase_by || "",
        is_expiry_available: initialData.is_expiry_available || false,
        expiry_month_year: initialData.expiry_month_year || "",
        is_expired: initialData.is_expired || false,
        unit: initialData.unit || "",
        quantity: initialData.quantity || "",
        damaged: initialData.damaged || "", // Changed to boolean
        return_prod: initialData.return_item || "", // Changed to boolean
    });


    useEffect(() => {
        if(initialData){
            // Format purchase_date as yyyy-MM-dd if it exists
            let formattedPurchaseDate = initialData.purchase_date || "";
            if (formattedPurchaseDate) {
                // If it's not already in yyyy-MM-dd, try to format it
                const d = new Date(formattedPurchaseDate);
                if (!isNaN(d)) {
                    const yyyy = d.getFullYear();
                    const mm = String(d.getMonth() + 1).padStart(2, '0');
                    const dd = String(d.getDate()).padStart(2, '0');
                    formattedPurchaseDate = `${yyyy}-${mm}-${dd}`;
                }
            }
            setFormData({
                raw_product_id: initialData.raw_product_id || "",
                product_name: initialData.product_name || "",
                product_code: initialData.product_code || "",
                item_number: initialData.item_number || "",
                supplier_id: initialData.supplier_id || "", // Corrected supplier_id initialization
                purchase_date: formattedPurchaseDate,
                purchase_by: initialData.purchase_by || "",
                is_expiry_available: initialData.is_expiry_available || false,
                expiry_month_year: initialData.expiry_month_year || "",
                is_expired: initialData.is_expired || false,
                unit: initialData.unit || "",
                quantity: initialData.quantity || "",
                damaged: initialData.damaged || "", // Changed to boolean
                return_prod: initialData.return_item || "", // Changed
            });
        }
        // handleProductChange();
        const selectedProduct = rawProducts.find((f) => f.id == initialData.raw_product_id );
        if (selectedProduct) {
            setFormData((prevData) => ({
                ...prevData,
                raw_product_id: selectedProduct.id,
                product_name: selectedProduct.name,
                product_code: selectedProduct.sku,
                unit: selectedProduct.RawCategory?.Unit?.name,
            }));
            setSelectedVendors(selectedProduct.RawProductVendors || []);
        }
    },[initialData]);

    // Function to handle product selection and update other fields
    const handleProductChange = (e) => {
        const selectedProduct = rawProducts.find((f) => f.id == e.target.value);
        if (selectedProduct) {
            setFormData((prevData) => ({
                ...prevData,
                raw_product_id: selectedProduct.id,
                product_name: selectedProduct.name,
                product_code: selectedProduct.sku,
                unit: selectedProduct.RawCategory?.Unit?.name,
            }));
            setSelectedVendors(selectedProduct.RawProductVendors || []);
        }
    };

    // Update selectedProduct and variantStock when product changes
    useEffect(() => {
        const prod = rawProducts.find((f) => f.id == formData.raw_product_id);
        setSelectedProduct(prod);
        console.log('Selected Product:', prod); // Debug log
        if (prod && prod.product_type === 'variants') {
            let parsedVariants = prod.variants;
            if (typeof parsedVariants === 'string') {
                try { parsedVariants = JSON.parse(parsedVariants); } catch { parsedVariants = []; }
            }
            console.log('Parsed Variants:', parsedVariants); // Debug log
            if (Array.isArray(parsedVariants) && parsedVariants.length > 0 && parsedVariants.every(v => Array.isArray(v.selectedTags))) {
                const combos = cartesian(parsedVariants);
                // If editing and initialData.variant_stock exists, prefill quantities
                let variantStockPrefill = combos.map(comb => ({
                    combination: comb,
                    quantity: '',
                    serial_no: [], // Initialize serial numbers as an empty array
                    price: '',
                    page_no: '',
                    remarks: ''
                }));
                if (initialData && initialData.variant_stock) {
                    let savedStock = initialData.variant_stock;
                    if (typeof savedStock === 'string') {
                        try { savedStock = JSON.parse(savedStock); } catch { savedStock = []; }
                    }
                    // Helper to compare combinations
                    const isSameCombo = (a, b) => {
                        if (!Array.isArray(a) || !Array.isArray(b) || a.length !== b.length) return false;
                        return a.every((item, idx) => item.attributeId == b[idx].attributeId && item.value == b[idx].value);
                    };
                    variantStockPrefill = combos.map(comb => {
                        const found = savedStock.find(s => isSameCombo(s.combination, comb));
                        return {
                            combination: comb,
                            quantity: found ? found.quantity : '',
                            serial_no: found ? (Array.isArray(found.serial_no) ? found.serial_no : []) : [],
                            price: found ? found.price : '',
                            page_no: found ? found.page_no : '',
                            remarks: found ? found.remarks : ''
                        };
                    });
                }
                setVariantStock(variantStockPrefill);
            } else {
                setVariantStock([]);
            }
        } else {
            setVariantStock([]);
        }
    }, [formData.raw_product_id, rawProducts, initialData]);

    // Utility to generate cartesian product of variants
    function cartesian(arr) {
        if (!Array.isArray(arr) || arr.length === 0) return [];

        // Filter out any entries where selectedTags is empty or falsy
        const filtered = arr.filter(a => Array.isArray(a.selectedTags) && a.selectedTags.length > 0);

        if (filtered.length === 0) return [];

        return filtered.reduce((a, b) =>
            a.flatMap(d =>
            b.selectedTags
                .filter(e => e !== null && e !== undefined && String(e).trim() !== '') // Skip blanks
                .map(e => [...d, { attributeId: b.attributeId, value: e }])
            )
        , [[]]);
        }


    // Handle form field changes
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === "checkbox" ? checked : value, // Handle checkboxes properly
        }));
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        const apiUrl = initialData.id ? `${API_URL}/raw-material-stock/${initialData.id}` : `${API_URL}/raw-material-stock`;
        const httpMethod = initialData.id ? 'put' : 'post'; // Use 'put' for updating, 'post' for adding

        try {
            const company = JSON.parse(localStorage.getItem('company'));
            const companyId = company.company?.id;
            const formDataObj = new FormData();

            // Append existing form data to FormData
            Object.keys(formData).forEach(key => {
                formDataObj.append(key, formData[key]);
            });

            // Append company_id
            formDataObj.append('company_id', companyId);
            // If variantStock is present, add it as JSON
            console.log('selectedProduct:', selectedProduct);
            console.log('selectedProduct.product_type:', selectedProduct?.product_type);
            console.log('variantStock.length:', variantStock.length);
            console.log('variantStock:', variantStock);
            
            if (selectedProduct && selectedProduct.product_type === 'variants' && variantStock.length > 0) {
                console.log('Appending variant_stock to FormData');
                formDataObj.append('variant_stock', JSON.stringify(variantStock));
            } else {
                console.log('NOT appending variant_stock - conditions not met');
            }
            const response = await axios[httpMethod](apiUrl, formDataObj);
            console.log('Data submitted successfully:', response.data);
            window.location.reload();
            onClose(); // Close the modal after successful submission
        } catch (error) {
            console.error('Error submitting data:', error);
        }
    };


     const handleAdd = () => {
        setModalHeading('Create New Product');// No supplier means we are adding a new one
        setShowModal(true);
    };


    return (
        <>
        <Modal show={show} onClose={onClose} heading={heading}>
            <form className="row" onSubmit={handleSubmit}>
                <div className="form-group col-md-6 mt-4">
                    <label className="w-100" htmlFor="product_id">Product <button type="button" onClick={handleAdd} className="float-end btn btn-primary">Add Product</button></label>
                    <select
                        className="form-control"
                        name="raw_product_id"
                        id="product_id"
                        value={formData.raw_product_id}
                        onChange={handleProductChange}
                        required
                    >
                        <option value="">Select Product</option>
                        {rawProducts.map((product) => (
                            <option key={product.id} value={product.id}>
                                {product.name}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="form-group col-md-6 mt-4">
                    <label htmlFor="product_name">Product Name</label>
                    <input
                        className="form-control"
                        type="text"
                        name="product_name"
                        id="product_name"
                        value={formData.product_name}
                        readOnly
                    />
                </div>

                <div className="form-group col-md-6 mt-4">
                    <label htmlFor="product_code">Product Code / SKU / Article Number</label>
                    <input
                        className="form-control"
                        type="text"
                        name="product_code"
                        id="product_code"
                        value={formData.product_code}
                        readOnly
                    />
                </div>

                {/* <div className="form-group col-md-6 mt-4">
                    <label htmlFor="item_number">Item Number / Serial Number</label>
                    <input
                        className="form-control"
                        type="text"
                        name="item_number"
                        id="item_number"
                        value={formData.item_number}
                        onChange={handleChange}
                        required
                    />
                </div> */}

                <div className="form-group col-md-6 mt-4">
                    <label htmlFor="supplier">Supplier</label>
                    <select
                        className="form-control"
                        name="supplier_id"
                        id="supplier"
                        value={formData.supplier_id}
                        onChange={handleChange}
                        required
                    >
                        <option value="">Select Supplier</option>
                        {selectedVendors.map((vendor) => (
                            <option key={vendor.suppliers.id} value={vendor.suppliers.id}>
                                {vendor.suppliers.name}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="form-group col-md-6 mt-4">
                    <label htmlFor="purchase_date">Purchase Date</label>
                    <input
                        className="form-control"
                        type="date"
                        name="purchase_date"
                        id="purchase_date"
                        value={formData.purchase_date}
                        onChange={handleChange}
                        required
                    />
                </div>

                

                <div className="form-group col-md-6 mt-4">
                    <label htmlFor="expiry_month_year">Expiry Month & Year</label>
                    <input
                        className="form-control"
                        type="month"
                        name="expiry_month_year"
                        id="expiry_month_year"
                        value={formData.expiry_month_year}
                        onChange={handleChange}
                    />
                </div>

                <div className="form-group col-md-6 mt-4">
                    <label htmlFor="unit">Unit</label>
                    <input
                        className="form-control"
                        type="text"
                        name="unit"
                        id="unit"
                        readOnly
                        value={formData.unit}
                    />
                </div>

                {/* Only show single quantity input if not a variant product */}
                {!(selectedProduct && selectedProduct.product_type === 'variants') && (
                <div className="form-group col-md-6 mt-4">
                    <label htmlFor="quantity">Quantity</label>
                    <input
                        className="form-control"
                        type="number"
                        name="quantity"
                        id="quantity"
                        value={formData.quantity}
                        onChange={handleChange}
                        required
                    />
                </div>
                )}

                {/* <div className="form-group col-md-6 mt-4">
                    <label htmlFor="damaged">Damaged</label>
                    <input
                        type="number"
                        name="damaged"
                        className="form-control"
                        id="damaged"
                        checked={formData.damaged}
                        onChange={handleChange}
                    />
                </div>

                <div className="form-group col-md-6 mt-4">
                    <label htmlFor="return_item">Return</label>
                    <input
                        type="number"
                        className="form-control"
                        name="return_prod"
                        id="return_item"
                        checked={formData.return_prod}
                        onChange={handleChange}
                    />
                </div> */}
                <div className="form-check col-md-3 mt-5 pt-2">
                        <input
                            type="checkbox"
                            name="is_expiry_available"
                            id="is_expiry_available"
                            checked={formData.is_expiry_available}
                            onChange={handleChange}
                            style={{ width: "20px", height: "20px" }}
                        />
                        <label className="form-check-label ms-3 " htmlFor="is_expiry_available">Is Expiry Available?</label>
                    </div>
                    <div className="form-check col-md-3 mt-5 pt-2">
                        <input
                            type="checkbox"
                            name="is_expired"
                            id="is_expired"
                            checked={formData.is_expired}
                            onChange={handleChange}
                            style={{ width: "20px", height: "20px" }}
                        />
                        <label className="form-check-label ms-2 " htmlFor="is_expired">Is Expired?</label>
                    </div>
                {/* Variant Stock Table or warning */}
                {selectedProduct && selectedProduct.product_type === 'variants' && (
                    <>
                        {variantStock.length > 0 ? (
                            <div className="col-12 mt-4">
                                <h5>Variant Stock</h5>
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            {selectedProduct.variants && (typeof selectedProduct.variants === 'string' ? JSON.parse(selectedProduct.variants) : selectedProduct.variants).map((v, idx) => (
                                                <th key={idx}>Attribute {v.attributeId}</th>
                                            ))}
                                            <th>Quantity</th>
                                            <th width="30%">Serial Number </th>
                                            <th>Price </th>
                                            <th>Page No. </th>
                                            <th>Remarks </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {variantStock.map((row, idx) => (
                                            <tr key={idx}>
                                                {row.combination.map((c, i) => <td key={i}>{c.value}</td>)}
                                                <td>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        value={row.quantity}
                                                        onChange={e => {
                                                            const newQuantity = parseInt(e.target.value) || 0;
                                                            const currentSerialCount = row.serial_no ? row.serial_no.length : 0;
                                                            
                                                            if (newQuantity < currentSerialCount) {
                                                                alert(`Cannot set quantity to ${newQuantity}. You already have ${currentSerialCount} serial numbers. Please remove some serial numbers first.`);
                                                                return;
                                                            }
                                                            
                                                            const updated = [...variantStock];
                                                            updated[idx].quantity = e.target.value;
                                                            setVariantStock(updated);
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    <div className="tags-input-container">
                                                        <div className="tags-display">
                                                            {Array.isArray(row.serial_no) ? row.serial_no.map((tag, tagIndex) => (
                                                                <span key={tagIndex} className="tag">
                                                                    {tag}
                                                                    <button
                                                                        type="button"
                                                                        className="tag-remove"
                                                                        onClick={() => removeTag(idx, tag)}
                                                                    >
                                                                        ×
                                                                    </button>
                                                                </span>
                                                            )) : null}
                                                        </div>
                                                        <input
                                                            type="text"
                                                            className="form-control tag-input"
                                                            value={tagInputs[idx] || ''}
                                                            onChange={(e) => handleTagInputChange(idx, e.target.value)}
                                                            onKeyPress={(e) => handleTagInputKeyPress(idx, e)}
                                                            placeholder="Type and press Enter to add serial number"
                                                        />
                                                    </div>
                                                    <style jsx>{`
                                                        .tags-input-container {
                                                            border: 1px solid #ced4da;
                                                            border-radius: 0.375rem;
                                                            padding: 0.375rem 0.75rem;
                                                            background: white;
                                                        }
                                                        .tags-display {
                                                            display: flex;
                                                            flex-wrap: wrap;
                                                            gap: 0.25rem;
                                                            margin-bottom: 0.25rem;
                                                        }
                                                        .tag {
                                                            background: #007bff;
                                                            color: white;
                                                            padding: 0.125rem 0.5rem;
                                                            border-radius: 0.25rem;
                                                            font-size: 0.875rem;
                                                            display: flex;
                                                            align-items: center;
                                                            gap: 0.25rem;
                                                        }
                                                        .tag-remove {
                                                            background: none;
                                                            border: none;
                                                            color: white;
                                                            cursor: pointer;
                                                            font-size: 1rem;
                                                            padding: 0;
                                                            line-height: 1;
                                                        }
                                                        .tag-input {
                                                            border: none;
                                                            outline: none;
                                                            box-shadow: none;
                                                            padding: 0;
                                                        }
                                                    `}</style>
                                                </td>
                                                <td>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        value={row.price || ''}
                                                        placeholder="Price"
                                                        onChange={e => {
                                                            const updated = [...variantStock];
                                                            updated[idx].price = e.target.value;
                                                            setVariantStock(updated);
                                                        }}
                                                    />
                                                </td>
                                            
                                                <td>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        value={row.page_no || ''}
                                                        placeholder="Page No"
                                                        onChange={e => {
                                                            const updated = [...variantStock];
                                                            updated[idx].page_no = e.target.value;
                                                            setVariantStock(updated);
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={row.remarks || ''}
                                                        placeholder="Remarks"
                                                        onChange={e => {
                                                            const updated = [...variantStock];
                                                            updated[idx].remarks = e.target.value;
                                                            setVariantStock(updated);
                                                        }}
                                                    />
                                                </td>
                                                        
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <div className="col-12 mt-4">
                                <div className="alert alert-warning">
                                    This product is a variant product, but no valid variant combinations were found.<br/>
                                    Please check the product's variants data.
                                </div>
                            </div>
                        )}
                    </>
                )}
                <div>
                <button type="submit" className="btn btn-primary mt-4">Save</button>
                </div>
            </form>
        </Modal>
        <AddPurchases show={showModal} onClose={() => setShowModal(false)} heading={modalHeading}  onSubmit={handleFormSubmit} categories={rawCategories} suppliers={suppliers} />
        </>
    );
};

export default RawMaterialStockForm;
